import moment from "moment-timezone";
import { DEFAULT_TIMEZONE } from "types";

const getTimezone = (timezone: string | undefined): string => timezone ?? DEFAULT_TIMEZONE;

export const toStartOfDayInTimezone = (date: Date, timezone: string | undefined): string =>
  moment.tz(getDateParts(date), getTimezone(timezone)).startOf("day").utc().toISOString();

export const toEndOfDayInTimezone = (date: Date, timezone: string | undefined): string =>
  moment.tz(getDateParts(date), getTimezone(timezone)).endOf("day").utc().toISOString();

export const getCurrentDateInTimezone = (timezone: string | undefined): Date => {
  const m = moment.tz(getTimezone(timezone));
  return new Date(m.year(), m.month(), m.date());
};

export const isToday = (date: Date, timezone?: string): boolean => {
  const tz = getTimezone(timezone);
  const now = moment.tz(tz);
  return date.getFullYear() === now.year() && date.getMonth() === now.month() && date.getDate() === now.date();
};

const getDateParts = (date: Date) => ({
  year: date.getFullYear(),
  month: date.getMonth(),
  date: date.getDate(),
});
